import { Injectable, inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { AutoclassifierSdkService } from '../../autoclassifier-sdk/autoclassifier-sdk.service';
import { ITPIntegrationSourceCreate } from '../../../models/integration.model';
import { SourcesResponse } from '@softdocs/capture-ui-libraries';

@Injectable({
  providedIn: 'root'
})
export class ItpIntegrationSourceService {
  private authService = inject(AuthService);
  private autoclassifierSdkService = inject(AutoclassifierSdkService);

  /**
   * Get all ITP Integration Sources for tenant
   * @returns {Promise<SourcesResponse[]>} - List of sources
   */
  getITPIntegrationSource(): Promise<SourcesResponse[]> {
    const accessToken = this.authService.getAuthToken()!;
    return this.autoclassifierSdkService.itpIntegrationSourceService.getITPIntegrationSource(
      accessToken
    );
  }

  /**
   * Get ITP Integration Sources by transcript type ID
   * @param {number} transcriptMetadataTypeId - transcript type ID
   * @returns {Promise<SourcesResponse[]>} - List of sources
   */
  getITPIntegrationSourceByTranscriptId(
    transcriptMetadataTypeId: number
  ): Promise<SourcesResponse[]> {
    const accessToken = this.authService.getAuthToken()!;
    return this.autoclassifierSdkService.itpIntegrationSourceService.getITPIntegrationSourceByTranscriptType(
      accessToken,
      transcriptMetadataTypeId
    );
  }

  /**
   * Create a new ITP Integration Source
   * @param {ITPIntegrationSourceCreate} data - source data to create
   * @returns {Promise<ITPIntegrationSourceCreate>} - created source
   */
  addITPIntegrationSource(data: ITPIntegrationSourceCreate): Promise<ITPIntegrationSourceCreate> {
    const accessToken = this.authService.getAuthToken()!;
    return this.autoclassifierSdkService.itpIntegrationSourceService.addITPIntegrationSource(
      accessToken,
      data
    );
  }

  /**
   * Update an existing ITP Integration Source
   * @param {string} id - source ID to update
   * @param {ITPIntegrationSourceCreate} data - source data to update
   * @returns {Promise<ITPIntegrationSourceCreate>} - updated source
   */
  updateITPIntegrationSource(
    id: string,
    data: ITPIntegrationSourceCreate
  ): Promise<ITPIntegrationSourceCreate> {
    const accessToken = this.authService.getAuthToken()!;
    return this.autoclassifierSdkService.itpIntegrationSourceService.updateITPIntegrationSource(
      accessToken,
      id,
      data
    );
  }

  /**
   * Delete an ITP Integration Source
   * @param {string} id - source ID to delete
   * @returns {Promise<string>} - deletion confirmation message
   */
  deleteITPIntegrationSource(id: string): Promise<string> {
    const accessToken = this.authService.getAuthToken()!;
    return this.autoclassifierSdkService.itpIntegrationSourceService.deleteITPIntegrationSource(
      accessToken,
      id
    );
  }
}
